import Layout from "./Layout.jsx";
import FinishedGoods from "../components/FinishedGoods.jsx";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getMe } from "../features/authSlice.js";

function FinishedGoodsPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError, user } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getMe());
  }, [dispatch]);

  useEffect(() => {
    if (isError) navigate("/");
  }, [isError, navigate]);

  return (
    <>
      {user && (
        <Layout>
          <FinishedGoods />
        </Layout>
      )}
    </>
  );
}

export default FinishedGoodsPage;
